export default __webpack_public_path__ + "b18224836f60257c46b3f2680807d391.png";